import { render, staticRenderFns } from "./ContentTextBlock.vue?vue&type=template&id=4229c658"
import script from "./ContentTextBlock.vue?vue&type=script&lang=js"
export * from "./ContentTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports